export default "__VITE_ASSET__C256VY83__"